const utils = {
  getDateTime(str) {
    let aux = str.split(",");
    if (aux.length > 1) {
      var date_aux = aux[0].split("/")
      var horu_aux = aux[1]
      var date = null;
      if (horu_aux.indexOf("AM") > -1 || horu_aux.indexOf("PM") > -1) {
        var hour = 0;
        if (horu_aux.indexOf('AM')) {
          horu_aux = horu_aux.replace('AM', '').trim()
        } else {
          hour = 12;
          horu_aux = horu_aux.replace('PM', '').trim()
        }
        horu_aux = horu_aux.split(':')
        date = new Date(Date.UTC(date_aux[2], parseInt(date_aux[0]) -1, date_aux[1], (parseInt(horu_aux[0])+hour), horu_aux[1], horu_aux[2]))
      } else {
        date = new Date(Date.UTC(date_aux[2], parseInt(date_aux[1]) -1, date_aux[0], horu_aux[0], horu_aux[1], horu_aux[2]))
      }

      
      var newDate = this.formatLocaleDate(date, 5)
      return newDate.toLocaleString();
    } else {
      aux = str.split("T");
      if (aux.length > 1) {
        // var date_aux = aux[0].split("-")
        // var horu_aux = aux[1].split(":")
        // var date = new Date(Date.UTC(date_aux[0], parseInt(date_aux[1]) -1, date_aux[2], horu_aux[0], horu_aux[1], horu_aux[2].split('.')[0]))
        var date = new Date(str)
        var newDate = this.formatLocaleDate(date, 0)
        return newDate.toLocaleString();
      }
    }
    return str;
  },
  formatLocaleDate(date, hour) {
    var numberOfMlSeconds = date.getTime();
    var addMlSeconds = (hour * 60) * 60000;
    var newDate = new Date(numberOfMlSeconds + addMlSeconds);
    newDate = new Date(Date.UTC(newDate.getUTCFullYear(), newDate.getUTCMonth(), newDate.getUTCDate(), newDate.getUTCHours(), newDate.getUTCMinutes(), newDate.getUTCSeconds()))
    return newDate;
  },
  getTextoHora:(value)=>{
  	switch(value){
  		case '06:00:00': return '6:00 am'; break; 
      case '07:30:00': return '7:30 am'; break; 
      case '08:00:00': return '8:00 am'; break;
      case '09:00:00': return '9:00 am'; break; 
      case '09:30:00': return '9:30 am'; break;
      case '10:30:00': return '10:30 am'; break; 
      case '11:00:00': return '11:00 am'; break;
      case '12:00:00': return '12:00 pm'; break; 
      case '13:00:00': return '1:00 pm'; break;
      case '13:30:00': return '1:30 pm'; break; 
      case '15:00:00': return '3:00 pm'; break; 
      case '16:30:00': return '4:30 pm'; break; 
      case '18:00:00': return '6:00 pm'; break; 
      case '19:30:00': return '7:30 pm'; break; 
  	}
  	return value
  },
  eliminarCaracteres(str) {
    if (str) {
      const sustitutions = {
        àáâãäå: "a",
        ÀÁÂÃÄÅ: "A",
        èéêë: "e",
        ÈÉÊË: "E",
        ìíîï: "i",
        ÌÍÎÏ: "I",
        òóôõö: "o",
        ÒÓÔÕÖ: "O",
        ùúûü: "u",
        ÙÚÛÜ: "U",
        ýÿ: "y",
        ÝŸ: "Y",
        ß: "ss",
        ñ: "n",
        Ñ: "N"
      };
      // Devuelve un valor si 'letter' esta incluido en la clave
      function getLetterReplacement(letter, replacements) {
        const findKey = Object.keys(replacements).reduce(
          (origin, item, index) => (item.includes(letter) ? item : origin),
          false
        );
        return findKey !== false ? replacements[findKey] : letter;
      }
      // Recorre letra por letra en busca de una sustitución
      ////////////////////////////////////////////////////////////////////////////////////////////
      // str = str.split("").map((letter) => getLetterReplacement(letter, sustitutions)).join("");
      return str.replace(/[^a-zA-Z0-9À-ÿ+()¡!¿?., -]+/g,'');
    }
    else return "";
  },
  LETTER_REGEX: /^[a-zA-Z0-9À-ÿ+()¡!¿?., -]+$/
};

export default utils;